import { createAction } from '@reduxjs/toolkit'

export const setMagicCategories = createAction<any[]>('magicBgTool/setMagicCategories')
export const setSuggestedImagesFromServer = createAction<any[]>('magicBgTool/setSuggestedImagesFromServer')
